const RoleUtils = {
    readOnly: function () {
        return ["AP_Inquiry"];
    },
    editOnly: function () {
        return ["AP_Inquiry", "AP_Admin", "Site_Admin", "Supplier_Admin"];
    },
    supplierRolesOnly: function () {
        return ["Supplier_Inquiry", "Supplier_Admin"];
    },
    uhgRolesOnly: function () {
        return ["AP_Inquiry", "AP_Admin", "Site_Admin", "AP_Worklist"];
    },
    profileRoles: function () {
        return ["AP_Admin", "AP_Inquiry", "Site_Admin","SP_Inquiry", "SP_Edit_NB", "SP_Edit_Bank"];
    },
    profileEditNoBankRoles: function () {
        return ["SP_Edit_NB"];
    },
    profileEditBankRoles: function () {
        return ["SP_Edit_Bank"];
    },
    optumWorklistOnlyRole: function () {
        return ["AP_Worklist"];
    },
    optumWorklistRoles: function () {
        return ["AP_Worklist", "AP_Admin", "Site_Admin"];
    },
    allWorklistRoles: function () {
        return ["AP_Worklist", "SP_Edit_Bank"];
    },
    worklistPageAccessRoles: function () {
        return ["AP_Worklist", "SP_Edit_Bank", "AP_Admin", "Site_Admin"];
    },
    optumAdminPerms: function () {
        return ["AP_Admin","Site_Admin"];
    },
    allAdminPerms: function () {
        return ["AP_Admin", "Supplier_Admin","Site_Admin"];
    },
    apAdminPerms: function () {
        return ["AP_Admin", "AP_Inquiry"];
    },
    inquiryPerms: function () {
        return ["AP_Inquiry", "Supplier_Inquiry", "AP_Admin", "Supplier_Admin", "Site_Admin"];
    },
    apInquiryPerms: function () {
        return ["AP_Inquiry", "AP_Admin", "Site_Admin"];
    },
    supplierAdminPerms: function () {
        return ["Supplier_Admin", "Supplier_Inquiry", "AP_Admin", "Site_Admin"];
    },
    supplierInquiryPerms: function () {
       return ["Supplier_Inquiry", "AP_Admin", "Supplier_Admin", "Site_Admin"];
    },
    maintainPortalAccessPerms: function () {
        return ["AP_Admin", "Supplier_Admin", "Site_Admin", "AP_Inquiry"];
    },
    allPerms: function () {
        return ["AP_Admin", "Supplier_Admin", "Site_Admin", "AP_Inquiry", "Supplier_Inquiry", "SP_Inquiry", "SP_Edit_NB", "SP_Edit_Bank", "AP_Worklist"];
    },
    supplierPortalUserAdminPerm: function () {
        return [ "Supplier_Admin"];
    },
    canAccess: function (currentUser, currentSupplierId, permissionArr) {
        var userRoles = [];
        currentUser.suppliers.forEach(function (supplier) {
            if (supplier.supplierId === currentSupplierId) {
                supplier.contactRoles.forEach(function (role) {
                    userRoles.push(role.description);
                });
            }
        });

        return (userRoles.filter(element => permissionArr.includes(element))).length>0;
    },
    getCurrentRoles: function (currentUser, currentSupplierId) {
        var userRoles = [];
        currentUser.suppliers.forEach(function (supplier) {
            if (supplier.supplierId === currentSupplierId) {
                supplier.contactRoles.forEach(function (role) {
                    var roleName = role.displayName.split(',');
                    userRoles.push(roleName[0]);
                });
            }
        });

        return userRoles;
    },
    roleIntToName: function (roleId) {
        if (roleId === 1) {
            return roleId = 'UHG AP Admin';
        } else if (roleId === 2) {
            return roleId = 'UHG AP Inquire';
        } else if (roleId === 3) {
            return roleId = 'Supplier Portal User Admin';
        } else if (roleId === 4) {
            return roleId = 'Supplier Invoice Payment Inquire';
        } else if (roleId === 5) {
            return roleId = 'UHG IT Admin';
        } else if (roleId === 6) {
            return roleId = 'Locked';
        } else if (roleId === 7) {
            return roleId = 'Disabled';
        } else if(roleId === 9) {
            return roleId = 'Supplier Profile Inquire';
        } else if (roleId === 10) {
            return roleId = 'Supplier Profile Edit-Non Banking';
        } else if (roleId === 11) {
            return roleId = 'Supplier Profile Edit-Banking';
        } else if (roleId === 12) {
            return roleId = 'UHG AP Worklist';
        }
    },
    getRoleStatus: function (id, roles) {
        var role = roles.find(({ roleId }) => roleId === id);
        if (role) {
            return role.enabled;
        }
        else {
            return false;
        }
    },
    setRoleStatus: function (id, roles, status,statusNotes) {
     
        var role = roles.find(({ roleId }) => roleId === id);
        if (role) {
            role.enabled = status;
        }
        else {
            //Add Role
            roles.push({
                roleId: id,
                description: RoleUtils.roleIntToName(id),
                enabled: true,
                statusNotes: statusNotes
            });

        }
        return roles;       
    },
    checkSPUAAccessOnRole: function (id, roles) {
        var role = roles.find(({ roleId }) => roleId === id);
        if (role) {
            //DEBUG console.log(`Role Id: ${id} has Notes: ${role.statusNotes}`);
            return (role.statusNotes);
        }
        else {
            return false;
        }
    },
    allowedMaintenanceAccess: function (currentUser, currentSupplierId) {
        var hasAccess = false;
        for (var i = 0; i < currentUser.suppliers.length; i++) {
            var supplier = currentUser.suppliers[i];
            if (supplier.supplierId === currentSupplierId) {
                hasAccess = supplier.allowMaintenanceMode;
                break;
            }
        }
        return hasAccess;
    },
    determineMaintenanceModeNav: function (currentUser, currentCompanyId,navItemPrems) {
      
        var hasAdminAccess = this.canAccess(currentUser, currentCompanyId, this.optumAdminPerms());
        var navTest = this.canAccess(currentUser, currentCompanyId, navItemPrems);
        var maintenanceTest = (hasAdminAccess === false) ? this.allowedMaintenanceAccess(currentUser, currentCompanyId) : true;
        var emeaTest = ((currentUser.hasEMEASupplier && !currentUser.hideEMEANav) || !currentUser.hasEMEASupplier);

        return (navTest && maintenanceTest && emeaTest);
    }
}
export default RoleUtils;